import { json } from "utils/http/client";

export const WorkOrderApi = {
  create: (data) => json(`/org/work-order/create/`, { method: "POST", body: data }),
  listByContractor: (contractorId) =>
    json(`/org/workorders/by-contractor/`, {
      method: "POST",
      body: { contractor_id: Number(contractorId) },
    }),
  updatePayment: (workOrderId, data) =>
    json(`/org/workorders/${Number(workOrderId)}/update-payment/`, {
      method: "PATCH",
      body: data,
    }),
  getById: (workOrderId) =>
    json(`/org/workorders/${Number(workOrderId)}/`, { method: "GET" }),
  updateContract: (workOrderId, payload) =>
    json(`/org/workorders/${Number(workOrderId)}/update-contract/`, {
      method: "PATCH",
      body: payload,
    }),
  getContractHistory: (workOrderId) =>
    json(`/org/workorders/${Number(workOrderId)}/contract-history/`, {
      method: "GET",
    }),
  getPaymentHistory: (contractorId) =>
    json(`/org/contractors/${Number(contractorId)}/payment-history/`, {
      method: "GET",
    }),

};


